export const USER_RELATION_TYPES = [
  { id: 'SCOUT', name: 'Partner' },
  { id: 'MAIN_FINANCIAL_ADVISOR', name: 'Hlavný špecialista' },
  { id: 'ADDITIONAL_FINANCIAL_ADVISOR', name: 'Pomocný špecialista' },
];

export const SERVICE_AREA_TYPES = [
  { id: 'LIFE_INSURANCES', name: 'životné poistenie' },
  { id: 'NON_LIFE_INSURANCES', name: 'neživotné poistenie' },
  { id: 'INVESTMENTS', name: 'kapitálový trh (investície)' },
  { id: 'LOANS', name: 'úvery' },
  { id: 'DEPOSITS', name: 'príjímanie vkladov' },
  { id: 'SUPPLEMENTARY_PENSION_SAVINGS', name: 'doplnkové dôchodkové sporenie' },
  { id: 'RETIREMENT_PENSION_SAVINGS', name: 'starobné dôchodkové sporenie' },
  { id: 'REAL_ESTATE', name: 'realitné služby' },
  { id: 'ALTERNATIVE_FORMS_OF_ASSET_APPRECIATION', name: 'alternatívne formy zhodnocovania' },
];
